<aside [ngClass]="{'hide-sidebar': hideSidebar}">
    <!-- <div id="siderbar__overlay" class="d-none"></div> -->
    <div id="ipjSidebar" class="sidebar hide-on-mobile pd-b20 pd-t30">
        <a href="javascript:void(0)" class="sidebar__closebtn hide-on-mobile d-flex font-25 link-no-underline "
            onclick="closeNav()">
            <span class="light-color">&lsaquo;</span>
        </a>
        <div class="light-bg sidebar__wrapper">
            <div class="sidebar__user d-flex align-items-center ">
                <div class="sidebar__profile--pic mg-t15" (click)="navigateToDashboard()">
                    <img src="assets/new-dashboard/logo-yellow.png" alt="" class="sidebar__user--img" />
                    <span>Learning Insights</span>
                </div>
            </div>
            <div class="sidebar_closed_logo d-flex align-items-center " (click)="navigateToDashboard()">
                <div class="sidebar__profile--pic mg-t15">
                    <img src="assets/new-dashboard/closed_menu_logo.svg" alt="" class="sidebar__user--img" />
                </div>
            </div>
            <ul class="sidebar__menu mg-t30 list-none">
                <li>
                    <a onclick="closeNavMobile()" routerLink="/learning-insights" routerLinkActive="active_menu" [routerLinkActiveOptions]="{exact: true}"
                        class="dark-color mg-b10 link-no-underline d-block">
                        <img src="assets/new-dashboard/home-active.png" alt="" class="sidebar__icon active" />
                        <img src="assets/new-dashboard/home.png" alt="" class="sidebar__icon inactive" /><p>Home</p></a>
                </li>
                <li>
                    <a onclick="closeNavMobile()" routerLink="/learning-insights/block"  routerLinkActive="active_menu" class="dark-color mg-b10 mg-t10 link-no-underline d-block" [routerLinkActiveOptions]="{exact: false}">
                        <img src="assets/new-dashboard/verified.png" alt="" class="sidebar__icon inactive" />
                        <img src="assets/new-dashboard/program-active.png" alt="" class="sidebar__icon active" /><p>Program Elements</p>
                    </a>
                </li>

                <li>
                    <a onclick="closeNavMobile()" routerLink="/learning-insights/learners" routerLinkActive="active_menu" 
                        class="dark-color mg-b10 mg-t10 link-no-underline d-block">
                        <img src="assets/new-dashboard/school.png" alt="" class="sidebar__icon inactive" />
                        <img src="assets/new-dashboard/learner-active.png" alt="" class="sidebar__icon active" /><p>Learners</p>
                    </a>
                </li>

                <!-- <li>
                    <a routerLinkActive="active_menu" routerLink="/dashboard/reports"
                        class="dark-color mg-b10 mg-t10 link-no-underline d-block">
                        <img src="assets/new-dashboard/download-active.png" alt="" class="sidebar__icon active" />
                        <img src="assets/new-dashboard/download.png" alt="" class="sidebar__icon inactive" />Download Reports
                    </a>
                </li> -->
            </ul>
            <ul class="sidebar__menu bottom-menu mg-t30 list-none">
                <li class="faq-bottom">
                    <a onclick="closeNavMobile()" routerLink="/learning-insights/faq" routerLinkActive="active_menu"
                        class="dark-color mg-b10 mg-t10 link-no-underline d-block cursor-pointer">
                        <img src="assets/new-dashboard/contact_support.png" alt="" class="sidebar__icon inactive" />
                        <img src="assets/new-dashboard/faq-active.png" alt="" class="sidebar__icon active" /><p>FAQ</p>
                    </a>
                </li>
                <li>
                    <a onclick="closeNavMobile()" class="dark-color mg-b10 mg-t10 link-no-underline d-block cursor-pointer" (click)="logout()">
                        <img src="assets/new-dashboard/logout.png" alt="" class="sidebar__icon inactive" /> <p>Logout</p></a>
                </li>

            </ul>
        </div>
    </div>
</aside>